import apiClient from '@/services/apiClient';
import apiAuthClient from '@/services/apiAuthClient';

import errorHandler from '@/utilities/serverErrorHandler';

export const settings = {
  namespaced: true,
  state: {
    eoiDownloaded: false,
    appDownloaded: false,
    claimsDownloaded: false,
    hcDownloaded: false,
    parentSectors: [],
    sectors: [],
    eoiDocumentStatus: false,
    applicationDocumentStatus: false
  },

  getters: {
    getEoiDownloaded: (state) => {
      return state.eoiDownloaded;
    },
    getAppDownloaded: (state) => {
      return state.appDownloaded;
    },
    getHcDownloaded: (state) => {
      return state.hcDownloaded;
    },
    getClaimsDownloaded: (state) => {
      return state.claimsDownloaded;
    },
    getParentSectors: (state) => {
      return state.parentSectors;
    },
    getSectors: (state) => {
      return state.sectors;
    },
    getDocumentStatus: state => (itemType, status) => {
      return status === 3 ? state[itemType] : false;
    }
  },
  mutations: {
    UPDATE_DOWNLOADED_FLAG (state, payload) {
      state[payload.flagName] = payload.flagStatus;
    },
    SET_PARENT_SECTORS (state, payload) {
      state.parentSectors = payload;
    },
    SET_SECTORS (state, payload) {
      state.sectors = payload;
    },
    UPDATE_DOCUMENT_STATUS (state, payload) {
      state[payload.itemType] = payload.data;
    }
  },

  actions: {
    updateDownloadedFlag ({ commit }, payload) {
      commit('UPDATE_DOWNLOADED_FLAG', payload);
    },
    setParentSectors ({ commit }, payload) {
      apiClient.get('UMISECTORPARENT/GET').then((res) => {
        const parentSectors = [];
				if (res.status === 200) {
					res.data.forEach(item => {
						parentSectors.push({
							label: item.ua_sectorparent,
							value: item.ua_umisectorparentid
						});
					});
          commit('SET_PARENT_SECTORS', parentSectors);
					return true;
				}
			});
    },
    setSectors ({ commit }, payload) {
      apiClient.get('UMISECTOR/GET').then((res) => {
        const sectors = [];
				if (res.status === 200) {
					res.data.forEach(item => {
            sectors.push({
							label: item.ua_sector,
							value: item.ua_umisectorid,
							parentId: item.ua_sectorparent
						});
					});
          commit('SET_SECTORS', sectors);
					return true;
				}
			});
    },
    getDocManagementStatus ({ commit, rootGetters }, payload) {
      return apiAuthClient.get(`GetUploadButtonState?id=${payload.entityId}&entity=${payload.applicationTypeId}`, rootGetters['auth/getAccessToken']).then((res) => {
        if (res.status === 200) {
          commit('UPDATE_DOCUMENT_STATUS', { itemType: payload.itemType, data: res.data });
          return res.data;
        }
      }).catch((err) => {
        return errorHandler('docManagementStatusErrors', err);
      });
    }
  }
};
